import * as React from 'react';

const ClipboardChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 4H8V2h8v2zm2 2h-2V4h4v18H4V4h4v2H6v14h12V6zm-2 4H8V8h8v2zm0 4H8v-2h8v2zm0 4H8v-2h8v2z"
            fill="#4B4D63"
        />
    </svg>
);

ClipboardChunkySvg.displayName = 'ClipboardChunkySvg';
export default ClipboardChunkySvg;
